export const countriesEnum = {
  CA: 'CANADA',
  GB: 'UNITED_KINGDOM',
  US: 'UNITED_STATES',
};

export const warningToastTitle = 'Shipping Restriction';

export const warningToastContent = 'Sorry, this item cannot be delivered to your shipping location. Please choose a different delivery location.';

export const PAYMENT_FORM = 'fff-payments-v2';
